import i18n from 'i18next';
import { Trans, useTranslation } from 'react-i18next';
import step1Img from '../../../../assets/icons/how-it-works-1.svg';
import step2Img from '../../../../assets/icons/how-it-works-2.svg';
import step3Img from '../../../../assets/icons/how-it-works-3.svg';
import styles from './HowItWorks.module.scss';

const HowItWorks = () => {
    const { t } = useTranslation();

    const steps = [
        {
            number: 1,
            image: step1Img,
            imageWidth: 90,
            imageAspectRatio: '90 / 83',
            name: t('howItWorksTitle1'),
            description: i18n.t('howItWorksDesc1'),
        },
        {
            number: 2,
            image: step2Img,
            imageWidth: 90,
            imageAspectRatio: '1 / 1',
            name: t('howItWorksTitle2'),
            description: i18n.t('howItWorksDesc2'),
        },
        {
            number: 3,
            image: step3Img,
            imageWidth: 105,
            imageAspectRatio: '106 / 89',
            name: t('howItWorksTitle3'),
            description: i18n.t('howItWorksDesc3'),
        },
    ];

    return (
        <section className={styles.sectionContainer}>
            <div className={styles.whiteBackground} />
            <h2 className={styles.sectionTitle}>
                <Trans i18nKey="howFlykubeWorks">
                    How does <span>FlyKube works</span>
                </Trans>
            </h2>
            <div className={styles.stepsContainer}>
                {steps.map((step) => (
                    <div className={styles.step} key={step.number}>
                        <div className={styles.stepImage}>
                            <img
                                src={step.image}
                                style={{ width: step.imageWidth, aspectRatio: step.imageAspectRatio }}
                                alt=""
                            />
                        </div>
                        <p className={styles.stepNumber}>
                            {t('step')} {step.number}
                        </p>
                        <p className={styles.stepName}>{step.name}</p>
                        <p className={styles.stepDescription}>{step.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default HowItWorks;
